import { jsxs as o, jsx as l } from "react/jsx-runtime";
const v = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m32.01 5.97-20 15.95v32.05c0 2.21 1.79 4 4 4h36v-52h-20ZM32 11.08v10.93H18.3L32 11.08Zm16.01 42.89h-32V25.01h19V9.97h13v44Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m21.81 32.07.5 1.89H42.3l-.53-2H21.81v.11ZM21.81 38.65v.03l.53 1.97h19.98l-.53-2H21.81ZM21.93 45.34l.53 2h19.99v-.03l-.53-1.97H21.93Z"
        }
      )
    ]
  }
);
export {
  v as Bill
};
